import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import { NavigationService } from '../../../../services/navigation/navigation.service';
import { CommonService } from '../../../../services/common/common.service';
import { LanguagesDataService, LanguagesColumnsService } from '../../../services';
import { Language, LanguagesResult } from '../../../interfaces';
import { Column } from '../../../interfaces/column.interface';

@Component({
  selector: 'app-language-details',
  templateUrl: './language-details.component.html',
  styleUrls: ['./language-details.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class LanguageDetailsComponent implements OnInit, OnDestroy {

  public language: Language = {};
  public languages: Language[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public columns: Column[] = [];

  constructor(
    private translate: TranslateService,
    private common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private languagesDataService: LanguagesDataService,
    private languagesColumnsService: LanguagesColumnsService,

  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Language - Details');
        this.getLanguage(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.language !== 'undefined') {
      this.language = this.dynamicDialogConfig.data.language;
    }
    this.columns = this.languagesColumnsService.getColumns();
  }

  ngOnDestroy(): void {
  }

  getLanguage(id: number): void {
    this.isLoading = true;
    this.languagesDataService.getLanguage(id).subscribe((response: Language|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.language = response;
      }
    });
  }

  list() {
    this.router.navigate(['/languages']);
  }

  add() {
    this.router.navigate(['/languages/add']);
  }

  edit() {
    this.router.navigate(['/languages/edit/' + this.language.id]);
  }

}
@Component({
  selector: 'app-language-details',
  templateUrl: './language-details.component.html',
  styleUrls: ['./language-details.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogLanguageDetailsComponent extends LanguageDetailsComponent {
}

